import React, {Component} from 'react'
import '../css/main.css'
import '../css/helper.css'
import '../css/flexboxgrid.css'

import PackageJson from '../../package.json'

import Nav from './Nav/Nav'
import PageLinkArrow from './PageLinkArrow/PageLinkArrow'
import Footer from './Footer/Footer'
import Page from './Page/Page'

import LandingPage from './LandingPage/LandingPage'
import Venue from './Venue/Venue'
import Travel from './Travel/Travel'
import Accommodation from './Accommodation/Accommodation'

const appVersion = PackageJson.version
const navLinks = [
  {target: 'home', label: 'Home'},
  {target: 'venue', label: 'Venue'},
  {target: 'travel', label: 'Travel'},
  {target: 'accommodation', label: 'Accommodation'},
  {target: 'made-by', label: 'MadeBy'},
]

class App extends Component {
  render() {
    return (
      <div className="wedsite-app" data-app-version={appVersion}>
        <Nav items={navLinks}>
          <Page id="home">
            <LandingPage />
          </Page>
          <Page id="venue">
            <Venue />
          </Page>
          <PageLinkArrow to="travel" />
          <Page id="travel" odd="true">
            <Travel />
          </Page>
          <PageLinkArrow to="accommodation" />
          <Page id="accommodation">
            <Accommodation />
          </Page>
          <PageLinkArrow to="home" orientation="up" subtext="Top" />
          <Footer />
        </Nav>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/App.js